let API_URL = "";
let ADMIN_API_URL = "";
let WORK_PLATFORM_URL = "";
let PLATFORM_URL = "";
let API_BE_URL = "";

const hostname = window.location.hostname;

if (hostname === "localhost") {
  // Local development
  API_URL = "http://localhost:5002";
  ADMIN_API_URL = "http://localhost:5003";
  // CrowdPlat_Website Next app runs on port 3000 in dev
  WORK_PLATFORM_URL = "http://localhost:3000";
  PLATFORM_URL = "http://localhost:3000";  
  API_BE_URL = "http://localhost:8080";    
} else if (hostname.includes("52.25.159.196") || hostname.includes("staging")) {
  // Staging environment - use relative paths / staging IP
  API_URL = "";
  ADMIN_API_URL = "";
  WORK_PLATFORM_URL = "http://52.25.159.196";
  PLATFORM_URL = "http://52.25.159.196";    
  API_BE_URL  = "http://52.25.159.196";
} else {
  // Production
  // Recruitment frontend is served from work.crowdplat.com
  API_URL = "";
  ADMIN_API_URL = "https://hire.crowdplat.com";
  WORK_PLATFORM_URL = "https://work.crowdplat.com";  
  PLATFORM_URL = "https://www.crowdplat.com";
  API_BE_URL  = "https://www.crowdplat.com";
}

export default API_URL;
export { ADMIN_API_URL, WORK_PLATFORM_URL, PLATFORM_URL, API_BE_URL, API_URL};
